<template>
  <div class="account-tag">
    <span class="account-tag__title">
      {{ tag.title }}
    </span>

    <span class="account-tag__count">
      {{ tag.count }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'AccountTag',

  props: {
    /*
     * {
     *  title: String,
     *  count: Number,
     * }
     */
    tag: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.account-tag {
  display: flex;
  align-items: center;
  height: 32px;
  padding: 8px;
  border-radius: 4px;
  background: var(--bg-color, $color--basic-menu);
}

.account-tag__title,
.account-tag__count {
  font-size: 13px;
  line-height: 0;
  font-weight: 500;
  color: $color--basic-white;
}

.account-tag__title {
  margin-bottom: 8px;
}

.account-tag__title::after {
  position: relative;
  top: 3px;
  content: '';
  display: inline-block;
  width: 1px;
  height: 15px;
  margin: 0 6px;
  background: $color--basic-superdark-gray;
}
</style>
